import { render, staticRenderFns } from "./backdrop.vue?vue&type=template&id=1e124250&scoped=true&"
var script = {}
import style0 from "./backdrop.vue?vue&type=style&index=0&id=1e124250&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e124250",
  null
  
)

export default component.exports